import { axios } from '@/utils/request'

const api = {
  // queryMenuStatus: '/sso/menu/queryMenuStatus', // 获取用户状态
  // addMenuStatus: '/sso/menu/addMenuStatus', // 保存用户状态
  SaveAllRead: '/sso/msgNotice/saveAllRead' // 全部已读
}

export default api
// export const queryMenuStatus = params => axios.post(api.queryMenuStatus, params)
// export const addMenuStatus = params => axios.post(api.addMenuStatus, params)
export const SaveAllRead = async params => axios.post(api.SaveAllRead, params)
